<template>
    <v-container fluid>
        <wzvz_overview_all_hdr ref="wzvz_overview_all_hdr" :filter="filter" class="mb-2"  @updateView="updateView" @updateSearch="updateSearch"/>
        <wzvz_overview_all_lst ref="wzvz_overview_all_lst" @updateSelection="updateSelection"/>
    </v-container>
</template>
 
<script>
    import wzvz_overview_all_hdr from "@/components/wzvz/wzvz_overview_all_hdr.vue";
    import wzvz_overview_all_lst from "@/components/wzvz/wzvz_overview_all_lst.vue";

    export default {
        components: {
            wzvz_overview_all_hdr,
            wzvz_overview_all_lst,
        },    
        props: {
            filter: {
                type: String,
                required: true
            }
        }, 
        data() {
            return {
            }
        },    
        methods: { 
            updateSelection(newValue) {
                this.$refs.wzvz_overview_all_hdr.updateSelection(newValue);
            },
            updateView(newValue) {
                this.$refs.wzvz_overview_all_lst.listWzvzCompleted(newValue);
            }, 
            updateSearch(newValue) {
                this.$refs.wzvz_overview_all_lst.updateSearch(newValue);
            },
        }
    }
</script> 

<style scoped> 

</style>